/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { ConfigService } from '../../../core/services/config.service';
import { UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api/selectitem';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { Tab } from '../../../core/model/tab.model';
import { UserConfigService } from '../../../core/services/user-config.service';

@Component({
  selector: 'lms-query-view-filter-geo',
  templateUrl: './query-view-filter-geo.component.html',
  styleUrls: ['./query-view-filter-geo.component.scss']
})
export class QueryViewFilterGeoComponent implements OnInit, OnChanges {
  @Input() group: any;
  @Input() commonopsPicklist;
  @Input() tab: Tab;
  @Input() tabIndex: number;
  cities;
  selectedGeoView: string;
  geoList;
  geoForm: UntypedFormGroup;
  resetForm = false;
  @Input() geoDescriptionList: any;
  selectedGeoDescriptions: string[] = [];
  geoDescriptionLabel = '';
  managerDesk: any;
  managerDeskOption: SelectItem[];
  constructor(private staticDataStoreService: StaticDataStoreService, private userConfigService: UserConfigService, private configService: ConfigService) {
    // set initial data for all commoditylist
    this.getGeoList();
    const configdata = this.configService.getConfigData();
  }

  /**
   * @memberof QueryViewFilterGeoComponent
   */
  getGeoList() {
    this.geoList = [{
      label: 'SYSTEM',
      value: 'system'
    },
    {
      label: 'DESK',
      value: 'desk'
    },
    {
      label: 'OPERATING REGION',
      value: 'operating Region'
    },
    {
      label: 'OPERATING ZONE',
      value: 'operating Zone'
    }
  ];
  }

  /**
   * this is angular life cycle this method init when template load
   * @memberof QueryViewFilterGeoComponent
   */
  ngOnInit() {
    this.geoForm.controls['selectedGeoView'].setValue(this.tab.queryView.selectedGeoView ? this.tab.queryView.selectedGeoView : (this.geoList.length ? this.geoList[0].value : ''));
    if (this.tab.queryView.selectedGeoView !== 'system') {
      this.setGeoDescriptionLabelAndList(this.tab.queryView.selectedGeoView, true);
    }
  }

  /**
   * every time when input changes and before nginit it fire
   * @memberof QueryViewFilterGeoComponent
   */
  ngOnChanges() {
    this.geoForm = this.group;
    this.resetForm = this.tab.queryView.resetForm;
    if (this.tab && this.tab.queryView && this.tab.queryView.selectedGeoView !== 'system' && !this.resetForm) {
      this.setGeoDescriptionLabelAndList(this.tab.queryView.selectedGeoView, true);
    }
  }

  /**
   * by this method we check what is the geo value then set
   * their respective description value
   * @param {any} event
   * @memberof QueryViewFilterGeoComponent
   */
  checkGeoView(event) {
    this.geoDescriptionList = [];
    if (event.value === 'system') {
      this.geoDescriptionLabel = '';
    } else {
      this.setGeoDescriptionLabelAndList(event.value);
    }
  }

  /**
   * set geo description label and list
   * @param {any} value
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterGeoComponent
   */
  setGeoDescriptionLabelAndList(value, frominit?: boolean) {
    this.geoDescriptionLabel = value.charAt(0).toUpperCase() + value.slice(1);
    this.setgeoDescriptionList(value, frominit);
  }

  /**
   * set geo description list
   * @param {any} geoName
   * @param {boolean} frominit
   * @memberof QueryViewFilterGeoComponent
   */
  setgeoDescriptionList(geoName, frominit: boolean) {
    switch (geoName) {
      case 'desk':
        this.setDeskList(frominit);
        break;
      case 'region':
        this.setRegionList(frominit);
        break;
      case 'division':
        this.setCorridorList(frominit);
        break;
      case 'operating Zone':
        this.setZoneList(frominit);
        break;
      case 'operating Region':
        this.setopRegionList(frominit);
        break;
      default:
        break;
    }
  }

  /**
   * set desk list
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterGeoComponent
   */
  setDeskList(frominit?: boolean) {
    this.managerDesk = this.commonopsPicklist.masterData.zoneList;
    this.geoDescriptionList = [];
    for (let i = 0; i < this.managerDesk.length; i++) {
      this.geoDescriptionList.push({
        label: this.managerDesk[i].zoneCode + ' ' + this.managerDesk[i].zoneDescription,
        value: this.managerDesk[i].zoneCode


      });
    }
    if (frominit) {
      this.geoForm.controls['selectedGeoDescriptions'].setValue(
        (this.tab.queryView.selectedGeoDescriptions) ? this.tab.queryView.selectedGeoDescriptions : (this.geoDescriptionList.length ? this.geoDescriptionList[0].value : ''));
    } else {
      this.geoForm.controls['selectedGeoDescriptions'].setValue(
        this.geoDescriptionList.length ? this.geoDescriptionList[0].value : '');
    }

  }

  /**
   * set region list
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterGeoComponent
   */
  setRegionList(frominit?: boolean) {
    const regionList = this.commonopsPicklist.masterData.regionList;
    for (let i = 0; i < regionList.length; i++) {
      this.geoDescriptionList.push({
        label: regionList[i].regionDescription,
        value: regionList[i].regionAbbreviation
      });
    }
    if (frominit) {
      this.geoForm.controls['selectedGeoDescriptions'].setValue((this.tab.queryView.selectedGeoDescriptions) ? this.tab.queryView.selectedGeoDescriptions : (this.geoDescriptionList.length ? this.geoDescriptionList[0].value : ''));
    } else {
      this.geoForm.controls['selectedGeoDescriptions'].setValue(this.geoDescriptionList.length ? this.geoDescriptionList[0].value : '');
    }
  }

  /**
   * set zone list
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterGeoComponent
   */
  setZoneList(frominit?: boolean) {
    // const zoneList = this.commonopsPicklist.masterData.oprZoneList;
    const zoneList = this.commonopsPicklist.oprZoneList;
    const geoDescriptionList = [];
    for (let i = 0; i < zoneList.length; i++) {
      // this.geoDescriptionList.push({
      //   label: zoneList[i].regionDescription,
      //   value: zoneList[i].regionAbbreviation
      // });
      if(zoneList[i] && zoneList[i].oprZoneName){
        geoDescriptionList.push({
          label: zoneList[i].oprZoneName.trim(),
          value: zoneList[i].oprZoneCode
        });
      }
    }
    geoDescriptionList.sort((a,b) => {
        const aCode = a.label.toLowerCase();
        const bCode = b.label.toLowerCase();
        return aCode  < bCode ? -1 : bCode > aCode ? 1 : 0
    });
    this.geoDescriptionList = [...geoDescriptionList];
    if (frominit) {
      this.geoForm.controls['selectedGeoDescriptions'].setValue((this.tab.queryView.selectedGeoDescriptions) ? this.tab.queryView.selectedGeoDescriptions : (this.geoDescriptionList.length ? this.geoDescriptionList[0].value : ''));
    } else {
      this.geoForm.controls['selectedGeoDescriptions'].setValue(this.geoDescriptionList.length ? this.geoDescriptionList[0].value : '');
    }
  }

  /**
   * set operating region list
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterGeoComponent
   */
  setopRegionList(frominit?: boolean) {
    // const opRegionList = this.commonopsPicklist.masterData.oprRegionList;
    // regionAbbreviation: "MIDWEST", regionDescription:
    const opRegionList = this.commonopsPicklist.oprRegionList;
    const geoDescriptionList = [];
    for (let i = 0; i < opRegionList.length; i++) {
      // this.geoDescriptionList.push({
      //   label: opRegionList[i].regionDescription,
      //   value: opRegionList[i].regionAbbreviation
      // });
      if(opRegionList[i] && opRegionList[i].oprRegionName){
          geoDescriptionList.push({
          label: opRegionList[i].oprRegionName.trim(),
          value: opRegionList[i].oprRegionCode
        });
      }
    }
    geoDescriptionList.sort((a,b) => {
      const aCode = a.label.toLowerCase();
      const bCode = b.label.toLowerCase();
      return aCode  < bCode ? -1 : bCode > aCode ? 1 : 0
  });
  this.geoDescriptionList = [...geoDescriptionList];
    if (frominit) {
      this.geoForm.controls['selectedGeoDescriptions'].setValue((this.tab.queryView.selectedGeoDescriptions) ? this.tab.queryView.selectedGeoDescriptions : (this.geoDescriptionList.length ? this.geoDescriptionList[0].value : ''));
    } else {
      this.geoForm.controls['selectedGeoDescriptions'].setValue(this.geoDescriptionList.length ? this.geoDescriptionList[0].value : '');
    }
  }

  /**
   * set corridor list
   * @param {boolean} [frominit]
   * @memberof QueryViewFilterGeoComponent
   */
  setCorridorList(frominit?: boolean) {

    if (this.commonopsPicklist && this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.divisonList) {
      const divisionList = this.commonopsPicklist.masterData.divisonList;
      for (let i = 0; i < divisionList.length; i++) {
        this.geoDescriptionList.push({
          label: divisionList[i].divisionMenmonic + ' (' + divisionList[i].divisionName + ')',
          value: divisionList[i].divisionCode
        });

      }
      if (frominit) {
        this.geoForm.controls['selectedGeoDescriptions'].setValue(
          (this.tab.queryView.selectedGeoDescriptions) ? this.tab.queryView.selectedGeoDescriptions : (this.geoDescriptionList.length ? this.geoDescriptionList[0].value : ''));
      } else {
        this.geoForm.controls['selectedGeoDescriptions'].setValue(this.geoDescriptionList.length ? this.geoDescriptionList[0].value : '');
      }
    }
  }
}
